import { createSlice } from '@reduxjs/toolkit';

const initialState={
    device:null
}
export const deviceSlice = createSlice({
  name: 'device',
  initialState,
  reducers: {

    
    
      setDevice: (state, action) => {
        state.device = action.payload;
        
      },
      
    
    setLogoutDevice: (state,action)=>{
      state.device=null
    }
  },
});

export const {  setDevice,setLogoutDevice} = deviceSlice.actions;

export default deviceSlice.reducer;
